import React from 'react';
import SalesChart from './SalesChart';
import RankingTable from './RankingTable';
import SubscriptionOverlay from './SubscriptionOverlay';
import { CHART_COLORS } from '../constants';
import { formatCurrency, getMonthDisplay } from '../helpers';
import styles from '../summary.module.scss';

const ProductosSection = ({
  productsData,
  sortedProducts,
  totalProductSales,
  isPremium,
}) => {
  return (
    <div className={styles.reportGate}>
      <div className={`${styles.reportContent} ${!isPremium ? styles.blurred : ''}`}>
        {/* Metricas */}
        <div className={styles.reportMetrics}>
          <div className={styles.reportMetricCard}>
            <span className={styles.reportMetricLabel}>Total Productos</span>
            <span className={styles.reportMetricValue}>
              {formatCurrency(totalProductSales)}
            </span>
          </div>
          <div className={styles.reportMetricCard}>
            <span className={styles.reportMetricLabel}>Productos Vendidos</span>
            <span className={styles.reportMetricValue}>{sortedProducts.length}</span>
          </div>
          <div className={styles.reportMetricCard}>
            <span className={styles.reportMetricLabel}>Promedio / Producto</span>
            <span className={styles.reportMetricValue}>
              {formatCurrency(
                sortedProducts.length ? totalProductSales / sortedProducts.length : 0,
              )}
            </span>
          </div>
        </div>

        {/* Grafico horizontal + Leyenda */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <h2 className={styles.cardTitle}>Top Productos del Mes</h2>
              <span className={styles.cardCount}>
                {getMonthDisplay(productsData?.month)}
              </span>
            </div>
          </div>
          <div className={styles.chartLayout}>
            <div className={styles.chartPane}>
              <SalesChart data={sortedProducts} layout="vertical" height={320} />
            </div>
            <div className={styles.legendPane}>
              <h3 className={styles.legendHeading}>Productos</h3>
              <div className={styles.legendItems}>
                {sortedProducts.map((product, i) => (
                  <div key={product.name} className={styles.legendRow}>
                    <span
                      className={styles.legendDot}
                      style={{
                        backgroundColor: CHART_COLORS[i % CHART_COLORS.length],
                      }}
                    />
                    <span className={styles.legendName}>{product.name}</span>
                    <span className={styles.legendVal}>
                      {formatCurrency(product.total)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Tabla de ranking */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <h2 className={styles.cardTitle}>Ranking de Productos</h2>
              <span className={styles.cardCount}>
                Ordenados por valor — {getMonthDisplay(productsData?.month)}
              </span>
            </div>
          </div>
          <RankingTable data={sortedProducts} entityLabel="Producto" />
        </div>
      </div>

      {!isPremium && <SubscriptionOverlay />}
    </div>
  );
};

export default ProductosSection;
